<script lang="ts" setup>
const props = defineProps<{
  isActive?: boolean
}>()

const { isActive } = toRefs(props)
</script>

<template>
  <span
    class="h-4 min-w-4 flex-inline items-center justify-center rounded-full font-bold px-1 bg-darkGray text-white text-2.5 leading-3.5"
    :class="{
      'bg-softBlack!': isActive,
    }"
  >
    <slot />
  </span>
</template>
